import { render, staticRenderFns } from "./ActividadesForm.vue?vue&type=template&id=3ed44d01&scoped=true"
import script from "./ActividadesForm.vue?vue&type=script&lang=js"
export * from "./ActividadesForm.vue?vue&type=script&lang=js"
import style0 from "./ActividadesForm.vue?vue&type=style&index=0&id=3ed44d01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed44d01",
  null
  
)

export default component.exports